import { RelativeComponent } from './../../hospitalSetup/relative-codes/relative.component';
import { Component, OnInit, OnDestroy, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { ServiceHistoryService } from './service-history.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators'; import { Subject, Subscription } from 'rxjs';
import { PatientParms, EmrParms, EmergencyParms } from '../../shared/search-params';
import { ControlsParams, UserSessionService, spliceArrByPropVal, Action, UIAction, getDateObj, SharedDateService } from '../../shared';
import { CancelServiceComponent } from '../../pricing/cancel-service/cancel-service.component';
import { ToastService } from '../../blocks/toast/toast.service';
import { EnumServiceType } from '../../enumeration';
import { EnumPatServiceStatus } from '../../enumeration/enum-pat-service-status';
import { OrderTransName, CLEAR_ALL, RegPatServiceReducer } from '../transactions';
import { OrderPatientAction } from '../interface/patient-order-parms';
import { EventEmitterService } from '../../shared/event-emitter.service';
import { ModalService, SelectizeComponent } from '../../blocks';
import { NursingService } from '../nursing/nursing.service';
import { OrdersService } from '../requests-list/orders-list.service';
import { ActivatedRoute } from '@angular/router';
import { PatientVM } from '../../registeration/patients';
import { CashierTransCoverComponent } from '../../cashier/cashier-trans-cover';
import { DiscountServicesRequestComponent } from '../../cashier/cashier-trans/discount-services-request/discount-services-request.component';
import { imageUploadAllService } from '../../docu-manage-new/image-upload-all/image-upload-all.service';
import { DatePipe } from '@angular/common';
import { EmrReportWriteComponent } from '../../medical-recored/emr-reports/emr-report-write/emr-report-write.component';
import { EmrRadReportComponent } from '../../medical-recored/emr-reports/emr-rad-report/emr-rad-report.component';
@Component({
  selector: 'app-service-history',
  templateUrl: './service-history.component.html',
  styleUrls: ['./service-history.component.css']
})
export class ServiceHistoryComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  _showPatFlag: boolean = false
  allVisits: boolean = false
  @Output() private emitSelectedPatient: EventEmitter<PatientVM> = new EventEmitter<PatientVM>();
  @ViewChild('DiscountServicesRequest') DiscountServicesRequest: any;
  @ViewChild('EmrReportWrite') EmrReportWrite: any;

  @Input() myProfileTap: any;
  editableContent: boolean = true;


  @Input() set showPatFlag(value: boolean) {
    if (value) {
      this._showPatFlag = true
    } else {
      this._showPatFlag = false

    }
  }


  @Input()
  set fireShowResult(value: boolean) {
    if (value) {
      this._USS.subscribeToKey$('FIRESHOWRESULT')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (keys: any) => {
            if (keys && keys.value) {
              if (value) {
                this.onIconActionClick({ serial: 2326, nameEn: 'Show Result', nameAr: 'عرض النتيجه' }, keys.value);
              }
            }
          });
    }
  }

  clickEventSubscription: Subscription;
  editServiceStepRow: boolean
  // START I.HAMED
  historyData: any[] = [];
  docTransformRequests: any[] = [];
  bedTransformRequests: any[] = [];
  reserveTransformRequests: any[] = [];
  // END I.HAMED
  showServiceStepsData: boolean = false
  UI_STATE: EmrParms;
  isActive = 0;
  notPayedPatientsFlag: boolean = false;
  needRefresh = false;
  breadCrumbData: any;
  visitedActions = {};
  activeAction = 0;
  @ViewChild('Patients', { static: true }) PatientSelctize: SelectizeComponent
  @ViewChild('visitSerial') visitSelect: SelectizeComponent;
  dynamicComponent: any;
  DynamicComponent: any;
  @ViewChild('popup') content: any;
  @Input() openedAs: string;
  @Input() serviceNo: number;
  targetedService: any;
  @Input() emergencyTransformers: number;
  groupingArray: any[];
  filteredPatientList: any[];
  searchObj: EmergencyParms = <EmergencyParms>{};
  controlsParams: ControlsParams;
  serviceType: any;
  showprice: number;
  patFromInputs: any = <any>{};
  patientParms: PatientParms;
  patServices: any[];
  currentDetail: any;
  currentUser: any = {};
  risFlag: number;
  chargeUpdate: number
  sampleViewPatientScreen: number;
  userName: string = '';
  d: any = new Date();
  currentDateTime: any = new Date();
  constructor(private serviceHistoryService: ServiceHistoryService,
    private _USS: UserSessionService,
    private _eventEmitter: EventEmitterService,
    private _toastService: ToastService,
    public translate: TranslateService,
    private _NursingService: NursingService,
    private _modalService: ModalService,
    private _dateService: SharedDateService
    ,
    private datepipe: DatePipe,

    private _route: ActivatedRoute,
    private _userSessionService: UserSessionService,
    private _ordersService: OrdersService,
    private _imageUploadAllService: imageUploadAllService
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.clickEventSubscription = this._eventEmitter.getClickEvent()
      .subscribe((data: any) => {
        if (data) {
          this.onIconActionClick({ serial: 304 }, data);
        }
      })
    this.serviceType = +this._route.snapshot.params['mode'];
    this.risFlag = +this._route.snapshot.params['risFlag'];;

    let curDate: any = new Date();
    curDate = this.currentDateTime.setHours(curDate.getHours() - 1);
    this.currentDateTime = this.datepipe.transform(curDate, 'dd-MM-yyyy hh:mm a');
  }
  fromWhere: string = '';
  ngOnInit() {
    this.ValidityAmendmentCAF$()
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.userName = currentUser.userName;
    this.medicalDataForPatient$()
    this.getFinancialPosition();
    if (this.openedAs == 'TAP') {
      this.UI_STATE$();
      this.EmrPatient$();
      this.patServicesLoad();
    } else if
      (this._USS.getModalKey('ServiceHistoryComponent')) {
      this.patFromInputs = this._USS.getModalKey('ServiceHistoryComponent')['inputs'];
      this.fromWhere = this.patFromInputs.fromWhere;

      this.notPayedPatientsFlag = this.patFromInputs['notPayedPatientsFlag'] ? this.notPayedPatientsFlag = this.patFromInputs['notPayedPatientsFlag'] : false
      this.setDataToVisitsSelectize(this.patFromInputs);
      this.patServicesLoad();
      this.getPatService$();
    }
    else {
      this.getPatParmsFromCallData();
    }
  }
  exortReportAsWord(rep: any) {
    // ----------Azmio 1-11-2022
    let finalPath: string = '';
    debugger
    finalPath = rep.reportPath + rep.reportName;
    rep.extension = '.docx'
    rep.linkPath = '';
    rep.linkPath = this._imageUploadAllService.getReportByRegPatServiceSerial(finalPath);
    fetch(rep.linkPath)
      .then(response => response.blob())
      .then(blob => {
        console.log("Size" + blob.size, 'Type=' + blob.type)
        if (blob.size > 0 && blob.type) {
          const reader = new FileReader;
          reader.addEventListener('load', () => {
            let link = document.createElement("a");
            link.download = '%' + this.currentUser.secLoginId + '%' + '@' + this.currentUser.secLoginId + '@' + 'Patient' + rep.patCode + this.currentUser.secLoginId + "%" + this.currentDateTime + rep.extension;
            link.href = reader.result as any;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
          reader.readAsDataURL(blob);
        }
        else {
          if (this.translate.currentLang == 'ar') {
            this._toastService.activateMsg("التقرير غير موجود")
          }
          else {
            this._toastService.activateMsg("Report Not Exists")

          }
        }
      }).catch(error => { alert(error) })
      ;
  }
  getFinancialPosition() {
    let prev = this._USS.getSessionKey('SecLoginPrivileges');
    if (prev) {
      this.showprice = prev[0].financialPosition
    }

  }


  ValidityAmendmentCAF$() {
    this._USS.subscribeToKey$('SecLoginPrivileges')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.chargeUpdate = +keys.value[0]['chargeUpdate'];
        }
      })
  }


  medicalDataForPatient$() {
    this._USS.subscribeToKey$('MediacalDataForPatient').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.patFromInputs = keys.value;
          this.activeAction = 0
          this.emergencyTransformers = 0
          this.visitedActions[0] = true;
          this.patServicesLoad();
        }
      });
  }
  getPatService$() {
    this._USS.getModalKey$().pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.name == 'ServiceHistoryComponent' && keys.inputs) {
          this.patFromInputs = keys.inputs;
          this.notPayedPatientsFlag = this.patFromInputs['notPayedPatientsFlag'] ? this.notPayedPatientsFlag = this.patFromInputs['notPayedPatientsFlag'] : false
          this.setDataToVisitsSelectize(keys.inputs);
          this.patServicesLoad();
        }
      });
  }
  filteredConfirmedServices: any[] = [];
  //----------------------------- asmaa-------------
  getPatParmsFromCallData() {

    this._USS.subscribeToKey$('PatParmsFromCallData')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {

        if (keys.value) {
          this.patFromInputs = keys.value;
          // console.log(this.patFromInputs)
          this.patServicesLoad()
        }
      });
  }
  speciality: number
  onSpecialSelected() {
    if (this.visitSelect) {
      this.visitSelect.clear();
      this.visitSelect.clearItems();
      if (this.patientParms && this.patientParms.patCode)
        this.visitSelect.setFastSearchObjDynamicKey('PatCode', this.patientParms.patCode)
    }
  }
  serviceCode: number;
  visitSerial: number;
  getVisitSerial(ev: any) {

    if (ev && ev.code && !ev.AutoEmitted) {
      this.patFromInputs.visitFilter = 1;
      this.visitSerial = ev.code;
    } else {
      this.patFromInputs.visitFilter = 0;
      this.visitSerial = this.patFromInputs.visitSerial;
    }
  }

  //----------------------------
  patServicesLoad() {
    if (this.emergencyTransformers != 1) {
      this.patientParms = {};
      this.patientParms.patCode = this.patFromInputs.patCode;
      this.patientParms.visitSerial = this.patFromInputs.visitSerial;
      this.patientParms.visitsList = this.patFromInputs.visitsList;
      this.patientParms.serviceCode = this.serviceCode;
      this.patientParms.serviceType = this.serviceType;

      if (this.patFromInputs.visitFilter) {
        this.patientParms.visitFilter = this.patFromInputs.visitFilter;
        if (this.patFromInputs.visitFilter == 1 && this.visitSerial > 0)
          this.patientParms.visitSerial = this.visitSerial;
      }
      if (this.patientParms['notPayedPatientsFlag'] = 1) {
        this.patientParms.visitFilter = 1
      }
      if (this.patientParms.patCode == 0 || this.patientParms.patCode == null || this.patientParms.patCode == undefined) {
        this.patientParms.patCode = +this.patFromInputs.patientCode;
      }
      // this.patientParms.pageSize = 100;
      // this.patientParms.offset = 0;
      // console.log(this.patientParms)}
    }

    this.showServiceStepsData = false
    this.patientParms.visitFilter = this.allVisits ? 0 : 1

    if (this.patientParms.visitSerial || this.patientParms.patCode) {
      if (this.serviceType == 2) {
        //this.patientParms.visitSerial = null;
        this.patientParms.serviceType = this.serviceType;
      }
      this.serviceHistoryService.patServicesLoad(this.patientParms).pipe(
        takeUntil(this.ngUnsubscribe))
        .subscribe((result) => {
          // this.patServices = result.data;
          if (result && result.data) { }
          // if (this.visitSelect) {
          //   this.visitSelect.clear();
          //   this.visitSelect.clearItems();
          //   this.visitSelect.setFastSearchObjDynamicKey('PatCode', this.patientParms.patCode)
          // }
          let patServiceData = result.data ? result.data : [];
          this.historyData = result.data1 ? result.data1 : [];
          let patReguests = result.data2 ? result.data2 : [];
          if (this.serviceNo == 2) {
            this.patServices = patServiceData.filter(item => item.serviceType == 2);
          } else if (this.serviceNo == 1) {
            this.patServices = patServiceData.filter(item => item.serviceType == 1);
          } else {
            this.patServices = patServiceData;
          }
          if (patServiceData) {
            this.filteredConfirmedServices = patServiceData.filter(el => el.serviceStatusCode == 14 || el.serviceStatusCode == 13);
            this.filteredConfirmedServices.forEach(element => { element['status'] = 0; });
          }
          if (patReguests && patReguests.length > 0) {
            this.reserveTransformRequests = patReguests.filter(req => req.orderType == 1);
            this.docTransformRequests = patReguests.filter(req => req.orderType == 2);
            this.bedTransformRequests = patReguests.filter(req => req.orderType == 3);
          }
        })
    }
  }
  patientService: any = {}
  serviceMedicalSteps: any[] = []
  regPatServiceSerial: number;
  onRowSelect(event) {
    if (event.data) {

      this.patientService = event.data
      this.getPatientWithSerivcesWithMidecalSteps(event.data);
    }
  }
  patDataService: any;
  getPatientWithSerivcesWithMidecalSteps(searchObj: any) {
    this.serviceMedicalSteps = [];
    this.patDataService = searchObj
    searchObj.visitSerial = this.visitSerial;
    this._NursingService.getPatientWithSerivcesWithMidecalSteps(searchObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data && res.data.length) {
            if (searchObj.payed && searchObj['payed'] != null) {
              this.showServiceStepsData = true
            } else {
              this.showServiceStepsData = false;
            }
            if (this.myProfileTap && this.myProfileTap.viewOnlyFlag)
              this.editableContent = false;
            // else
            //   this.editableContent = keys.value.editableContent;
            this.serviceMedicalSteps = res.data;
            //  this.serviceMedicalSteps['editServiceStepRow'] = false
            this.serviceMedicalSteps.forEach(element => {
              element['editServiceStepRow'] = false;
              element['stepStatus'] = element['stepStatus'] == 4 ? true : false
            });


          }

        },
        error => console.log(error),
        () => { });
  }

  ngOnDestroy() {
    this.clickEventSubscription.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this._USS.setSessionKey('UI_STATE', {})
  }
  // --------------------subscriptions---------------
  UI_STATE$() {
    this._USS.subscribeToKey$('UI_STATE').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.value) {
          if (keys.value.tapCode == "ORDERHISTORY") {
            this.patServicesLoad();
          }
        }
      });
  }

  EmrPatient$() {
    this._USS.subscribeToKey$('EmrPatient').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.name == 'EmrPatient' && keys.value) {
          this.patFromInputs = keys.value;
          this.setDataToVisitsSelectize(keys.value);
          if (this.isActive) {
            this.patServicesLoad();

          } else { this.needRefresh = true; }
        }
      });
  }

  setDataToVisitsSelectize(value: any) {
    if (this.visitSelect) {
      this.visitSelect.clear();
      this.visitSelect.clearItems();
      this.visitSelect.setFastSearchObjDynamicKey('PatCode', value.patCode ? value.patCode : value.patientCode)
    }
  }

  // -------------------------------
  getActiveAction(_row: any, appCodes: any[]) {
    let activeActions = [];
    // 2326,2325,681"
    if (_row) {
      appCodes = spliceArrByPropVal(appCodes, 'serial', '682');
      this.serviceType = _row.serviceType
      if (_row.serviceType != EnumServiceType.Laboratory && _row.serviceType != EnumServiceType.Radiology) {
        appCodes = spliceArrByPropVal(appCodes, 'serial', '2326');
      }
      if (_row.serviceType != EnumServiceType.Laboratory) { // lab result confiermed
        appCodes = spliceArrByPropVal(appCodes, 'serial', '681');
        appCodes = spliceArrByPropVal(appCodes, 'serial', '689');
        appCodes = spliceArrByPropVal(appCodes, 'serial', '6387');
        // appCodes = spliceArrByPropVal(appCodes, 'serial', '2326');
      }
      if (_row.serviceType == EnumServiceType.Laboratory && (_row.servStatus != EnumPatServiceStatus.ResultInsured && _row.servStatus != EnumPatServiceStatus.ResultPrinted)) { // lab result confiermed
        appCodes = spliceArrByPropVal(appCodes, 'serial', '2326');
      }
      if (_row.serviceType != EnumServiceType.TeethOrder) {
        appCodes = spliceArrByPropVal(appCodes, 'serial', '2154');
      }
      //////////////////////// new

      if (_row.serviceType != EnumServiceType.Radiology) {
        appCodes = spliceArrByPropVal(appCodes, 'serial', '639');
      }
      if (_row.serviceType == EnumServiceType.Radiology && _row.servStatus == EnumPatServiceStatus.RadReviewReport) {
        appCodes = spliceArrByPropVal(appCodes, 'serial', '681');
      }
      if (_row.serviceType == EnumServiceType.Radiology && _row.servStatus != EnumPatServiceStatus.RadReviewReport && _row.servStatus != EnumPatServiceStatus.RadWriteReport) {
        appCodes = spliceArrByPropVal(appCodes, 'serial', '2326');
      }

      //////////////////////// end new

      // for lab result write
      if (_row.serviceType == EnumServiceType.Laboratory && (_row.servStatus == EnumPatServiceStatus.ResultInsured && _row.doneExternalFlag == 1)) { // lab result confiermed
        appCodes = spliceArrByPropVal(appCodes, 'serial', '681');
      }
      if (_row.serviceType == EnumServiceType.Laboratory && (_row.doneExternalFlag != 1)) { // lab result confiermed
        appCodes = spliceArrByPropVal(appCodes, 'serial', '681');
      }

      if (!_row.hasHtmlReport) { // lab result confiermed
        appCodes = spliceArrByPropVal(appCodes, 'serial', '637');
      }
      // if (_row.serviceType != EnumServiceType.Radiology && _row.serviceType != EnumServiceType.Laboratory && _row.serviceType != EnumServiceType.Emergency && _row.serviceType != EnumServiceType.Clinics) { //   service  that  can be  canceled  here
      //   appCodes = spliceArrByPropVal(appCodes, 'serial', '304');
      // }
      // if (_row.serviceType != EnumServiceType.Radiology && _row.servStatus != EnumPatServiceStatus.RadReviewReport) {
      //   appCodes = spliceArrByPropVal(appCodes, 'serial', '2326');
      // }
      /////-13 serg -14 catheter -15endscope
      // if (_row.serviceType != EnumServiceType.Surgery && _row.serviceType != EnumServiceType.Catheter && _row.serviceType != EnumServiceType.Endoscopy) { //   service  that  can be  canceled  here
      //   appCodes = spliceArrByPropVal(appCodes, 'serial', '6387');
      // }
      activeActions = appCodes;
      return activeActions;
    }
  }
  setReportvalue(Service: any) {

    this.targetedService = Service;
    this.filteredConfirmedServices.forEach(element => {
      element['status'] = 0;
    });
    Service.status = !Service.status;
  }
  // -------------------------------onIconActionClick
  onIconActionClick(action: any, Service: any) {
    this.setBreadCrumb('in', action.serial, `${action['nameAr']} ( ${Service['serviceNameAr']} ) `
      , `${action['nameEn']} ( ${Service['serviceNameEn']} ) `, action.serial);

    this.targetedService = Service;
    switch (action.serial) {
      case 2326:// show  result
        this._USS.setSessionKey(OrderPatientAction.Order_Next_AppCode, '2326')
        this._USS.setSessionKey(OrderPatientAction.Order_Pat_Service, { service: [Service] });
        break;
      case 681:// Write  result
        break;
      // case 682:// Write confirm result
      // break;
      case 2325: // Service Consumables
        //this._USS.setSessionKey('patient', Service['patientParms']);
        //this._USS.setSessionKey('ServiceId', Service['serviceId']);

        break;
      case 304:

        if ((Service.payed == null || Service.payed == -1) && Service.servStatus !== EnumPatServiceStatus.CheckOut && Service.servStatus !== EnumPatServiceStatus.Cancel || this.chargeUpdate == 1) {
          this.cancelClicked();
        }
        else if (Service.payed !== null) {
          this._toastService.activateMsg('UI14');
          this.onBreadCrumbClick(0);
          this.breadCrumbData = {};
          return false;
        }
        else if (Service.servStatus == EnumPatServiceStatus.Cancel) {
          this._toastService.activateMsg('UI24');
          this.onBreadCrumbClick(0);
          this.breadCrumbData = {};
          return false;
        }
        else {
          this._toastService.activateMsg('UI25');
          this.onBreadCrumbClick(0);
          this.breadCrumbData = {};
          return false;
        }
        break;
      case 637:
        if (this.targetedService.serviceType == 2) {
          // this._USS.setSessionKey(OrderPatientAction.Order_Next_AppCode, action.serial);
          this._USS.setSessionKey(OrderPatientAction.Order_Pat_Service, { service: Service });
        } else {
          let ServiceArr = [];
          ServiceArr.push(Service)
          this._USS.setSessionKey("hasHtmlReportSerial", { service: ServiceArr });
        }
        break;
      case 6387:
        this._USS.setSessionKey('In_Pat_Service', Service);
        this.currentDetail = Service;
        Service.patCode = this.patFromInputs.patCode;
        Service.visitSerial = this.patFromInputs.visitSerial;
        this.serviceType = Service.serviceType
        Service.workFlow = 2;
        this.manageTransactions(632);
        break;
      case 6765:
        this.writeNotes()
        break;
      case 7170:
        this.WriteReportToService(Service)
        break;

      case 7188:
        this.WriteReportToServiceTest(Service)
        break;


      case 2154:
        Service.serial = -1
        this.ReloadDentialCycleDoctor(Service)
        break;
      case 2493:
        //Edit Services
        Service.visitSerial = Service.vSerial;
        this._USS.setSessionKey('patientParms', Service);
        this.emitSelectedPatient.emit(Service);
        break;
        //  case 2001:
        //new Reservation
        // this._USS.setSessionKey('patientParms', {});
        break;
      case 306:
        this.cashierTrans(Service);
        break;
      case 2293:
        this.editPatientInfo(Service);
        break;
      case 7286:
        this.Retesting(Service);
        break;
      default:
        break;
    }

    Service.typeFlage = 2;//7;
    this._USS.setSessionKey('stockParms', Service);
    this._USS.setSessionKey('ServiceId', Service['serviceId']);

  }
  deleteRow(action: number, rowData: any) {
    if (action = 304) {
      this._modalService.activeMes(`الغاء الحجز`, `Refues Confirmation`).then(responseOK => {
        if (responseOK) {
          this.updateOrderStatus(rowData)
        }
      })
    }
  }
  updateOrderStatus(data: any) {
    data.orderSerial = data.serial
    data.OrderStatus = 4;
    this._ordersService.updateOrdersData(data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res && res.returnFlag) {

        }
      });
  }





  manageTransactions(operation: number): boolean {
    let action = <Action>{ type: UIAction.AddAndStepTrans, payload: '' }
    if (operation == 632) {//secheduling
      action.payload = OrderTransName.SavedOrderDetailScheduling;
      if (!this._USS.checkTransStatus(action)) {
        return false;
      };

    }
    this._USS.setUIStateAction(action);
    this._USS.setdispatcher(RegPatServiceReducer);
    this._USS.dispatch({ type: CLEAR_ALL, payload: [] });
    return true;
  }
  cashierTrans(Service: any) {
    // let data: any = <any>{}

    this.dynamicComponent = CashierTransCoverComponent;
    this._USS.setSessionKey("cashierParms", { visitSerial: Service.vSerial });
    this.content.openModal("CashierTransCoverComponent", "Reservations", Service);
    this._USS.getModalKey('CashierTransCoverComponent')['inputs'].SaveData = 0

  }
  editPatientInfo(Service: any) {
    // let data: any = <any>{}
    this._USS.setSessionKey("ModifyNameIdentity", { patCode: Service.code });

    // this.dynamicComponent = ModifyNameIdentityComponent;
    // this.content.openModal("ModifyNameIdentityComponent", "ModifyNameIdentityComponent", Service);

  }
  cancelClicked() {
    this.dynamicComponent = CancelServiceComponent;
    this.content.openModal("CancelServiceComponent", "Reservations", this.targetedService);
  }
  onpopupClose(parms: any) {
    this.onBreadCrumbClick(0);
    if (parms && parms.output == 'Cross click') {

    }
    else if (parms && parms.name == "xxxxxxxx" && parms.output) {
    }
    this.patServicesLoad();
    this.breadCrumbData = {};
  }
  onStepIconActionClick(action: any, row: any) {
    switch (action.serial) {
      case 404://
        row.editServiceStepRow = false;
        this.editServiceStep(row);
        break;
      case 7075://
        if (row.toBechargedServiceId) {

          this.chargeTreatmentPlanService(row);
        }
        break;
      case 7076://
        if (row.toBechargedServiceId) {

          this.cancelChargeTreatmentPlanService(row);
        }
      case 6552://

        this.repeatMedicalStep(row);

        break;
    }
  }
  chargeTreatmentPlanService(ser: any) {
    let serv: any = {}
    //const currentPat = this.getPatWithSearchParms();
    serv.serial = -1
    serv.expectedStartTime = getDateObj(ser.regDate)
    serv.sessionSort = null
    serv.deviceId = null
    serv.nameAr = ser.nameAr
    serv.nameEn = ser.nameEn
    serv.comingFrom = 1
    serv.resourceId = ser.docId;
    serv.visitSerial = ser.visitSerial;
    serv.serviceId = ser.toBechargedServiceId;
    serv.examService = false,
      serv.servStatus = 1,
      serv.count = 1,
      serv.treatmentPlanSerial = ser.serial;
    this.serviceHistoryService
      .treatmentPlanCharge(serv)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (c) => {
          if (c["returnFlag"]) {
            //  this.getDBList();
          }
        },
        (error) => console.log(error)
      );
  }
  cancelChargeTreatmentPlanService(service: any) {
    if (service) {
      this.serviceHistoryService.treatmentPlanCancelCharge(service)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
        });
    }
  }
  ReloadDentialCycleDoctor(service: any) {
    this.serviceHistoryService.ReloadDentialCycleDoctor(service)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
      });

  }
  repeatMedicalStep(service: any) {

    service.serial = service.regPatMedicalStepsSerial
    service.stepStatus = +service.stepStatus
    service.dataStatus = 1
    this.serviceHistoryService
      .repeatRegPatMedicalStepService(service)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (c) => {
          if (c["returnFlag"]) {
            this.getPatientWithSerivcesWithMidecalSteps(this.patDataService);
          }
        },
        (error) => console.log(error)
      );
  }
  paginate(event) {

  }
  fullScreen: boolean = true;
  collapseScreen() {
    this.fullScreen = !this.fullScreen;
  }
  getCSSClasses(_row: any, index?: number) {
    let cssClasses = '';
    if (_row) {

      if (_row.abnormality == 0) {
        cssClasses = 'table-sucess';
      } else if (_row.abnormality == 1) {
        cssClasses = 'table-danger';
      } else if (_row.serviceStatusCode == 5) {
        cssClasses = 'deleted-row';
      }

      return cssClasses;
    }
  }

  //#region breadcrumb area
  onBreadCrumbClick(node) {
    if (node && node.code != 0) {
      this.activeAction = node.code;
      this.visitedActions[node.code] = true;
    } else {
      this.activeAction = 0;
      this.visitedActions[node] = true;
    }

  }

  setBreadCrumb(type: string, code, nameAr?, nameEn?, areaName?) {
    this.breadCrumbData = Object.assign({},
      { type: type, code: code, nameAr: nameAr, nameEn: nameEn, areaName: areaName });
    this.visitedActions[code] = true;
    this.activeAction = code;
  }
  getPatienTvisit(ev: any) {
    if (ev && ev != null && ev['AutoEmited'] == false) {
      this.visitSelect.clear();
      this.visitSelect.clearItems();
      this.visitSelect.setFastSearchKey('PatCode', ev.code);

    }
  }

  writeNotes() {
    this._USS.setSessionKey("NotesComponents", this.targetedService)
  }

  //#endregion
  onSearchClick(_parms: any) {
    this.searchObj = _parms;
    if (this.searchObj !== null) {
      this.searchObj.offset = 0;
      this.searchObj.visitType = 3;
      this.searchObj.pageSize = 10;
      this.searchObj.visitType = _parms.workStatus;
      this.patientParms = this.searchObj
      this.serviceHistoryService.RegEmergancyTransferLoad(this.patientParms).pipe(
        takeUntil(this.ngUnsubscribe))
        .subscribe((result) => {
          // this.patServices = result.data;
          if (result && result.data) { }
          let patServiceData = result.data ? result.data : [];
          this.historyData = result.data1 ? result.data1 : [];
          let patReguests = result.data2 ? result.data2 : [];
          if (this.serviceNo == 2) {
            this.patServices = patServiceData.filter(item => item.serviceType == 2);
          } else if (this.serviceNo == 1) {
            this.patServices = patServiceData.filter(item => item.serviceType == 1);
          } else {
            this.patServices = patServiceData;
          }
          if (patServiceData) {
            this.filteredConfirmedServices = patServiceData.filter(el => el.serviceStatusCode == 14 || el.serviceStatusCode == 13);
            this.filteredConfirmedServices.forEach(element => { element['status'] = 0; });
          }
          if (patReguests && patReguests.length > 0) {
            this.reserveTransformRequests = patReguests.filter(req => req.orderType == 1);
            this.docTransformRequests = patReguests.filter(req => req.orderType == 2);
            this.bedTransformRequests = patReguests.filter(req => req.orderType == 3);
          }
        })
    }
  }
  editServiceStep(row: any) {
    row['editServiceStepRow'] = !row['editServiceStepRow']
  }
  save() {
    this.serviceMedicalSteps.forEach(element => { element['stepStatus'] = element['stepStatus'] ? 4 : null });
    let serviceMedicalSteps = this.serviceMedicalSteps.filter(req => req.editServiceStepRow == true);
    this.serviceHistoryService.UpdateSerivceMedicalStep(serviceMedicalSteps)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        this.getPatientWithSerivcesWithMidecalSteps(this.patDataService);

      });
  }
  getServiceDiscount(item: any) {
    this.dynamicComponent = DiscountServicesRequestComponent;
    this._userSessionService.setSessionKey('DiscountServicesRequest', item)
    this.DiscountServicesRequest.openModal("DiscountServicesRequestComponent", item.serial);
  }
  addNewMedicalStep() {
    let newMedicalStep: any = {};
    newMedicalStep.serial = (this.serviceMedicalSteps.length + 1) * -1;
    newMedicalStep.regPatMedicalStepsSerial = (this.serviceMedicalSteps.length + 1) * -1;
    newMedicalStep.dataStatus = 1;
    newMedicalStep.visitSerial = this.serviceMedicalSteps[0].visitSerial;
    newMedicalStep.priServiceStpMedicalStepId = this.serviceMedicalSteps[0].priServiceStpMedicalStepId;
    newMedicalStep.regPatServiceSerial = this.serviceMedicalSteps[0].regPatServiceSerial;
    newMedicalStep.expectedDate = new Date();
    newMedicalStep.resourceId = this.serviceMedicalSteps[0].scheduleDocID;
    newMedicalStep.scheduleDocID = this.serviceMedicalSteps[0].scheduleDocID;
    newMedicalStep.notes = '',
      newMedicalStep.stepStatus = false,
      newMedicalStep.editServiceStepRow = true;
    // newMedicalStep.startDate = this._dateService.convertFromDateToNgBsObject(new Date());
    newMedicalStep.patCode = this.patFromInputs.patCode;;
    this.serviceMedicalSteps.push(newMedicalStep);
  }
  WriteReportToServiceTest(item: any) {
    this.DynamicComponent = EmrRadReportComponent;
    this._userSessionService.setSessionKey('EmrRadReportComponent', item)
    this.EmrReportWrite.openModal("EmrRadReportComponent", item);
  }
  WriteReportToService(item: any) {
    item.elnaeemReport = 1,
      this.DynamicComponent = EmrReportWriteComponent;
    this._userSessionService.setSessionKey('WriteReportToService', item)
    this.EmrReportWrite.openModal("EmrReportWriteComponent", item);
  }
  Retesting(item: any) {
    this._modalService.activeMes(`هل أنت متأكد من إعادة التحليل`, `Are You Sure Retesting`).then(responseOK => {
      if (responseOK) {
        this.serviceHistoryService.AddRegPatService(item)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => {
            if (res) {
              this.patServicesLoad();
            }
          });
      }
    });
  }



}
